import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Icon } from 'semantic-ui-react';
import './styles.css';

const CopyAccount = ({ account }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(account).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <span className="info-program-account" onClick={handleCopy} title="Copiar">
      {copied ? '✓ Copiado' : account}
    </span>
  );
};

const InfoCards = () => {
  const { t } = useTranslation();

  const infoItems = [
    { icon: 'user', title: t('info.dressCode.title'), description: t('info.dressCode.description') },
    { icon: 'car', title: t('info.parking.title'), description: t('info.parking.description') },
    {
      icon: 'hotel',
      title: t('info.hotels.title'),
      description: t('info.hotels.description'),
      links: [
        { label: 'Opción 1', url: 'https://www.booking.com/Share-kf0n38' },
        { label: 'Opción 2', url: 'https://www.booking.com/Share-qAw0QE' }
      ]
    },
    { icon: 'bus', title: t('info.transport.title'), description: t('info.transport.description') },
    { icon: 'gift', title: t('info.gifts.title'), description: t('info.gifts.description'), account: t('info.gifts.account') }
  ];

  return (
    <div className="info-program-wrapper">
      <Container>
        <p className="narrative-intro">{t('info.intro')}</p>
        <div className="info-program-panel">
          {infoItems.map((item, index) => (
            <div key={index} className="info-program-item">
              <Icon name={item.icon} className="info-program-icon" />
              <div className="info-program-content">
                <span className="info-program-title">{item.title}</span>
                <span className="info-program-desc">{item.description}</span>
                {item.account && (
                  <CopyAccount account={item.account} />
                )}
                {item.links && (
                  <div className="info-program-links">
                    {item.links.map((link, i) => (
                      <a key={i} href={link.url} target="_blank" rel="noopener noreferrer" className="info-program-link">
                        {link.label}
                      </a>
                    ))}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </Container>
    </div>
  );
};

export default InfoCards;
